var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgModuleIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.0018 0L14.4034 6.87629L22 7.97852L16.4997 13.3327L17.802 20.8978L11.002 17.3271L4.20717 20.8977L5.50251 13.333L0 7.97846L7.60178 6.87627L11.0018 0ZM11.002 2.2403L8.26076 7.78427L2.13697 8.67217L6.56961 12.9856L5.52554 19.083L11.0018 16.2052L16.4818 19.0828L15.4322 12.9859L19.8637 8.67211L13.7446 7.78425L11.002 2.2403Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgModuleIcon);
export default __webpack_public_path__ + "static/media/moduleIcon.c595525463427f0bc403bab5f4817ec1.svg";
export { ForwardRef as ReactComponent };